import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferred: BeforeInstallPromptEvent | null = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferred = e as BeforeInstallPromptEvent;
});

/** Installation is offered only after a first completed game, never before. */
export function InstallHint() {
  const { t } = useTranslation();
  const [available, setAvailable] = useState(deferred !== null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    const on = () => setAvailable(true);
    window.addEventListener('beforeinstallprompt', on);
    return () => window.removeEventListener('beforeinstallprompt', on);
  }, []);
  if (!available || dismissed || !deferred) return null;
  return (
    <aside className="card install">
      <p>{t('install.body')}</p>
      <div className="row">
        <button
          className="btn primary"
          onClick={async () => {
            await deferred?.prompt();
            deferred = null;
            setDismissed(true);
          }}
        >
          {t('install.cta')}
        </button>
        <button className="btn ghost" onClick={() => setDismissed(true)}>
          {t('install.later')}
        </button>
      </div>
    </aside>
  );
}
